<script setup>
import { handleError, ref, watch } from 'vue';
import { useConfigStore } from '@/stores/useConfigStore.js'
import Header from '@/components/Header.vue';
import EditComponent from './Edit.vue'
import Icon from '@/components/Icon.vue';
import BaseComponent from '@/components/BaseComponent.vue';
import { baseURL } from "@/libs/api.js";

const useConfig = useConfigStore();
const showEdit = ref(false);
const dataEdit = ref({});
const showDeleteAccount = ref(false);
const isBase = ref(false);
const animation = ref(false);
const user = ref({})
watch(
    () => useConfig.user,
    (newUser) => {
        if (newUser && Object.keys(newUser).length > 0) {
            user.value = newUser
        }
    },
    { immediate: true, deep: true }
)

const edit = () => {
    showEdit.value = true;
};
const handleCallData = (e) => {
    console.log(1, e);
}

const handleCallBack = (e) => {
    showEdit.value = false;
};

const showDelAcc = (e) => {
    isBase.value = true;
    showDeleteAccount.value = true;
}

const closeDelAcc = () => {
    animation.value = true
    setTimeout(() => {
        animation.value = false;
        showDeleteAccount.value = false;
        isBase.value = false;
    }, 200)
};

</script>
<template>
    <div class="w-full h-full animation_page overflow-auto">
        <Header text="Thông tin tài khoản" :url="{ name: 'user' }">
            <div @click="edit" class="w-full flex justify-end items-center">
                <svg class="w-5 h-5 fill-white" xmlns="http://www.w3.org/2000/svg" height="512pt" viewBox="0 0 512 511"
                    width="512pt">
                    <path
                        d="m405.332031 256.484375c-11.796875 0-21.332031 9.558594-21.332031 21.332031v170.667969c0 11.753906-9.558594 21.332031-21.332031 21.332031h-298.667969c-11.777344 0-21.332031-9.578125-21.332031-21.332031v-298.667969c0-11.753906 9.554687-21.332031 21.332031-21.332031h170.667969c11.796875 0 21.332031-9.558594 21.332031-21.332031 0-11.777344-9.535156-21.335938-21.332031-21.335938h-170.667969c-35.285156 0-64 28.714844-64 64v298.667969c0 35.285156 28.714844 64 64 64h298.667969c35.285156 0 64-28.714844 64-64v-170.667969c0-11.796875-9.539063-21.332031-21.335938-21.332031zm0 0" />
                    <path
                        d="m200.019531 237.050781c-1.492187 1.492188-2.496093 3.390625-2.921875 5.4375l-15.082031 75.4375c-.703125 3.496094.40625 7.101563 2.921875 9.640625 2.027344 2.027344 4.757812 3.113282 7.554688 3.113282.679687 0 1.386718-.0625 2.089843-.210938l75.414063-15.082031c2.089844-.429688 3.988281-1.429688 5.460937-2.925781l168.789063-168.789063-75.414063-75.410156zm0 0" />
                    <path
                        d="m496.382812 16.101562c-20.796874-20.800781-54.632812-20.800781-75.414062 0l-29.523438 29.523438 75.414063 75.414062 29.523437-29.527343c10.070313-10.046875 15.617188-23.445313 15.617188-37.695313s-5.546875-27.648437-15.617188-37.714844zm0 0" />
                </svg>
            </div>
        </Header>
        <div class="w-full h-auto pt-14">
            <div class="mb-4 bg-white h-auto divide-y px-6">
                <div class="w-full flex justify-start items-center py-4 gap-4">
                    <div class="flex-none w-16 h-16 rounded-full relative flex justify-center items-center border border-white">
                        <div v-if="user?.picture != []" class="w-full h-full bg-white rounded-full overflow-hidden">
                            <img :src="baseURL + user?.pictures[0]?.fullsize" alt="avatar" class="object-cover h-full w-full">
                        </div>
                        <div v-else
                            class="w-full h-full flex justify-center items-center bg-amber-600 rounded-full overflow-hidden">
                            <svg class="w-10 h-10 fill-white" xmlns="http://www.w3.org/2000/svg"
                                viewBox="-42 0 512 512.002">
                                <path
                                    d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
                                <path
                                    d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
                            </svg>
                        </div>
                    </div>
                    <div class="w-full h-full flex flex-col justify-center items-start">
                        <p class="font-bold">{{ user.name }}</p>
                        <div class="w-full h-auto flex justify-between">
                            <p class="text-gray-400 font-bold">{{ user.phone }}</p>
                            <div class="text-red-600 font-bold text-sm flex justify-end items-center gap-1">
                                <span>Xác thực ngay</span>
                                <Icon name="right" class="w-2 h-2 fill-gray-400"></Icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">Loại tài khoản</p>
                    <p class="flex-1 text-right text-gray-400"></p>
                </div>
            </div>
            <div class="mb-4 bg-white h-auto divide-y px-6">
                <div class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">Họ và tên</p>
                    <p class="flex-1 text-right text-gray-600">
                        {{ user.name }}
                    </p>
                </div>
                <div class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">Số điện thoại</p>
                    <p class="flex-1 text-right text-gray-600">
                        {{ user.phone }}
                    </p>
                </div>
                <div class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">Email</p>
                    <p class="flex-1 text-right text-gray-600">
                        {{ user.email }}
                    </p>
                </div>
                <div class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">Ngày sinh</p>
                    <p class="flex-1 text-right text-gray-600">
                        {{ user.information && user.information.birthday ? new Date(user.information.birthday).toISOString().split("T")[0] : '' }}
                    </p>
                </div>
                <div class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">CMND/CCCD</p>
                    <p class="flex-1 text-right text-gray-600">
                        {{user.information.idNumber}}
                    </p>
                </div>
            </div>
            <div class="mb-4 bg-white h-auto divide-y px-6">
                <div class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">Địa chỉ chi tiết</p>
                    <p class="flex-1 text-right text-gray-600">
                        {{user.address}}
                    </p>
                </div>
            </div>
            <div class="mb-4 bg-white h-auto divide-y px-6">
                <div @click="showDelAcc" class="w-full flex justify-start py-4">
                    <p class="flex-1 text-gray-400">Đóng tài khoản</p>
                    <p class="flex-1 flex justify-end items-center text-gray-600">
                        <Icon name="right" class="w-2 h-2 fill-gray-400"></Icon>
                    </p>
                </div>
            </div>
        </div>
        <edit-component v-model:show="showEdit" :data="dataEdit" @call-back="handleCallBack" @call-api="handleCallData" />
        <BaseComponent v-model:show="isBase">
            <transition name="slide-up">
                <div v-if="showDeleteAccount">
                    <div @click.stop class="absolute bottom-0 w-full h-auto min-h-20 float-end bg-white rounded-t-3xl overflow-hidden p-6 animation_up"
                    :class="{'animation_close_up': animation }">
                        <div @click="closeDelAcc" class="w-full flex justify-end items-center">
                            <Icon name="close" class="w-4 h-4 fill-gray-800"></Icon>
                        </div>
                        <div class="w-full flex flex-col justify-start items-center">
                            <p class="text-xl font-bold text-center py-4">
                                Bạn có chắc muốn đóng tài khoản?
                            </p>
                            <p class="text-sm text-center pb-8">
                                Tài khoản của bạn sẽ bị <b>tạm khóa</b> để chờ yêu cầu
                                được xét duyệt. Thời gian xét duyệt có thể lên đến <b>180 ngày.</b>
                            </p>
                            <button @click="closeDelAcc" class="w-full border border-main rounded py-2 text-main font-semibold">
                                Đóng tài khoản
                            </button>
                        </div>
                    </div>
                </div>
            </transition>
        </BaseComponent>
    </div>
</template>